import { Box, Typography } from '@mui/material';

const TestBanner = () => {
  const message = 'Non-Production Environment For TDS (Test Data Specialist) - For Testing Purposes Only.';

  if (process.env.REACT_APP_MODE === 'prod') {
    return null;
  }
  
  return (
    <Box
      className="test-banner"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '30px',
        backgroundColor: '#ff6b35',
        color: 'white',
        zIndex: 9999,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        className="banner-content"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'bold',
            fontSize: '15px',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default TestBanner;